import { useState } from 'react';
import {
  getEmptyConversationFromStorage,
  clearEmptyConversationFlag,
  setConversationInHash
} from '../utils/conversationUtils';

/**
 * Manages template selection, submission, and conversation state for templates
 */
export const useTemplateHandling = ({
  activeConversationId,
  messages,
  createConversation,
  switchConversation,
  loadUserConversations,
  chatInputRef,
  handleSendMessage,
  setShowTemplates
}) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [inputValue, setInputValue] = useState('');

  const handleTemplateClick = async (template) => {
    // Ensure we have an active conversation (reuse empty if available)
    const emptyConversation = getEmptyConversationFromStorage();
    
    if (!activeConversationId) {
      // No active conversation - check for empty one
      if (emptyConversation) {
        try {
          await switchConversation(emptyConversation);
          loadUserConversations(); // Refresh list
        } catch (error) {
          console.warn('⚠️ Stored empty conversation not found, creating new one');
          clearEmptyConversationFlag();
          const newConvId = await createConversation("");
          loadUserConversations(); // Refresh list
        }
      } else {
        const newConvId = await createConversation("");
        loadUserConversations(); // Refresh list
      }
    } else if (messages.length > 0) {
      // Current conversation has messages - need new empty one
      if (emptyConversation && emptyConversation !== activeConversationId) {
        try {
          await switchConversation(emptyConversation);
          loadUserConversations(); // Refresh list
        } catch (error) {
          console.warn('⚠️ Stored empty conversation not found, creating new one');
          clearEmptyConversationFlag();
          const newConvId = await createConversation("");
          loadUserConversations(); // Refresh list
        }
      } else {
        const newConvId = await createConversation("");
        loadUserConversations(); // Refresh list
      }
    }
    // If activeConversationId exists and has no messages, use it as-is
    
    setSelectedTemplate(template);
  };

  const handleTemplateSubmit = (finalQuery, shouldSend = false) => {
    if (finalQuery && finalQuery.trim()) {
      // Always populate the input
      setInputValue(finalQuery);
      setSelectedTemplate(null);
      setShowTemplates(false); // Close templates view
      
      // If shouldSend is true, also send the message
      if (shouldSend) {
        handleSendMessage(finalQuery);
      }
      
      // Focus the input after a short delay
      setTimeout(() => {
        if (chatInputRef.current) {
          chatInputRef.current.focus();
        }
      }, 100);
    }
  };

  const handleTemplateCancel = () => {
    setSelectedTemplate(null);
  };

  return {
    selectedTemplate,
    inputValue,
    setInputValue,
    handleTemplateClick,
    handleTemplateSubmit,
    handleTemplateCancel
  };
};

